module.exports = __webpack_public_path__ + "static/franck-04bc406f81c71b580ca4c8b669a8def9.png";